<template>
  <v-dialog persistent v-model="getDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">File Browser</v-card-title>

        <v-card-text>
            <vue-select-image
              :dataImages="dataImages"
              @onselectimage="onSelectImage">
            </vue-select-image>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="darken-1"
            text
            @click.prevent="close()">
            close
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import VueSelectImage from 'vue-select-image'
require('vue-select-image/dist/vue-select-image.css')

export default {
    id: "#browserDialog",
    data() {
      return {
          dataImages: []
      };
    },
    props: {
      dialog: {
        type: Boolean
      }
    },
    mounted() {
        this.importAll(require.context('../assets/icons/', true, /\.png$/));
    },
    computed: {
      getDialog(){
        return this.dialog;
      }
    },
    components: {
       VueSelectImage 
    } ,
    methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      importAll(r) {
        r.keys().forEach(key => (this.dataImages.push({ src: r(key), id: key, alt: '' })));
      },
      onSelectImage(e){
          this.$emit('selectIcon', `${location.origin}${e.src}`);
      }
    } 
}
</script>
<style lang="scss" scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
}
</style>
<style lang="scss">
.vue-select-image__img{
  height: 50px;
  width: 50px;
}

.vue-select-image__thumbnail--selected{
  background: #dbdbdb;
}
</style>